import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Clip = ({
  size,
  type,
  theme,
  className,
  dataTestId = "clip-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3749 3.62507C11.028 2.27809 8.8441 2.27809 7.49712 3.62507L4.01954 7.10265C3.75919 7.363 3.33708 7.363 3.07673 7.10265C2.81638 6.8423 2.81638 6.42019 3.07673 6.15984L6.55431 2.68226C8.42199 0.814587 11.4501 0.814585 13.3178 2.68226C15.1854 4.54994 15.1854 7.57803 13.3178 9.44571L8.59656 14.1669C7.19806 15.5654 4.93065 15.5654 3.53216 14.1669C2.13366 12.7684 2.13366 10.501 3.53216 9.1025L8.1551 4.47956C9.08753 3.54713 10.5993 3.54713 11.5317 4.47956C12.4641 5.41199 12.4641 6.92375 11.5317 7.85618L9.0952 10.2927C8.83486 10.553 8.41275 10.553 8.1524 10.2927C7.89205 10.0323 7.89205 9.61024 8.1524 9.34989L10.5889 6.91337C11.0006 6.50164 11.0006 5.8341 10.5889 5.42237C10.1772 5.01064 9.50964 5.01064 9.09791 5.42237L4.47497 10.0453C3.59717 10.9231 3.59717 12.3463 4.47497 13.2241C5.35276 14.1019 6.77595 14.1019 7.65375 13.2241L12.3749 8.5029C13.7219 7.15592 13.7219 4.97204 12.3749 3.62507Z"
    />
  </SVGIcon>
);
